import { useToastStore } from "&/toast";
import { IconCheckbox } from "@/Icon/Checkbox";
import { SequentialAnimation } from "@/SequentialAnimation";
import { Slide } from "@/Slide";
import { createFileRoute } from "@tanstack/react-router";
import { useCallback } from "react";
export const Route = createFileRoute("/business/layout/payment/test")({
  component: RouteComponent,
});
interface SlotProps {
  success?: boolean;
}
const LeftSlot = ({ success }: SlotProps) => {
  return (
    <div className="flex h-full rounded-r-lg bg-gray-700">
      <IconCheckbox active={success} />
      완료
    </div>
  );
};
const RightSlot = ({ success }: SlotProps) => {
  return (
    <div className="flex h-full rounded-l-lg bg-yellow">
      취소
      <IconCheckbox active={!success} />
    </div>
  );
};
function RouteComponent() {
  const { add } = useToastStore();
  const handleSubmit = useCallback(
    (value: boolean) => {
      add(value ? " 출석했습니다." : " 출석이 취소됐습니다.");
    },
    [add]
  );
  return (
    <SequentialAnimation>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
      <Slide
        onSubmit={handleSubmit}
        leftSlot={<LeftSlot />}
        rightSlot={<RightSlot />}
      >
        <div className="h-14">효섭이</div>
      </Slide>
    </SequentialAnimation>
  );
}
